import { ClockIcon } from "@heroicons/react/24/outline";
import { getWorkflowOffset } from "@sp-crm/core";
import React from "react";
import { DelayRecipeSource, useDelaySourceEditor } from "../delay-recipe-editor";
import { actionTimingMode } from "./builder-helper";
import {
    WaitAmountControls,
    WaitDefault,
    WaitModeSelect,
    WaitSaveFailure,
    WaitStatus,
} from "./wait-controls";
import { DEFAULT_ACTION_INTERVAL_RECIPE } from "./workflow-blueprint";

const [DEFAULT_WAIT_DELAY, DEFAULT_WAIT_UNIT] = getWorkflowOffset(
    DEFAULT_ACTION_INTERVAL_RECIPE,
);
const DEFAULT_WAIT: WaitDefault = { delay: DEFAULT_WAIT_DELAY, unit: DEFAULT_WAIT_UNIT };

interface ActionIntervalEditorProps {
    source: DelayRecipeSource;
    verb: string;
    timeline: string | null;
    onCommit: (delayRecipe: string) => Promise<void>;
}

export const ActionIntervalEditor: React.FC<ActionIntervalEditorProps> = props => {
    const { source, verb, timeline, onCommit } = props;
    const control = useDelaySourceEditor(source, onCommit);
    const mode = actionTimingMode(control.delay);

    if (!control.visible) {
        return null;
    }

    return (
        <div className="space-y-2">
            <div className="flex items-center gap-2 flex-wrap text-sm text-gray-600">
                <ClockIcon className="w-4 h-4 text-gray-400 shrink-0" />
                <span>{verb}</span>
                <WaitModeSelect control={control} defaultWait={DEFAULT_WAIT} />
                {mode === "immediately" ? (
                    <span>after the previous action</span>
                ) : (
                    <>
                        <span>of</span>
                        <WaitAmountControls control={control} minDelay={1} />
                        <span>from the previous action</span>
                    </>
                )}
                <WaitStatus control={control} timeline={timeline} />
            </div>
            <WaitSaveFailure control={control} />
        </div>
    );
};
